import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios'
import { Table, Icon, Button } from 'semantic-ui-react'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import * as UiConsts from '../../../../config/UiConstants';


class ViewLargeProjectDocSendMissingSlack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            docView: []
        }
    }

    componentDidMount() {
        // console.log("spjx31 ++++++++++ ViewLargeProjectDocChangeProjectType componentDidMount");
        // console.log("spjx33: filter:" + this.props.projectId)
    }

 

    sendMissingSlack = (projectType) => {
        console.log("spjx1 ++++++++:setProjectType");
        console.log("spjx12 projectType:" + projectType)

        this.setState({ loading: true })

        axios.post(pythonApiIp + 'sendMissingDocSlackNotif', {
            apiKey: "asdfsdf&343k",
            projectId: this.props.projectId,
            enteredBy: this.props.user.email,
            docType: this.props.item
        })
            .then((response) => {
                this.setState({ loading: false })

              //  console.log("gdocx1 results:" + JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                   // console.log("gdocx1true.. got docs");
                    this.setState({ docView: response.data.docView })

                    this.props.reload();

                } else {
                    console.log("FAILED");
                    //  alert(response.data.message);
                }
            })
            .catch((error) => {
                this.setState({ loading: false })
                console.log("extt1:" + error);

            });
    }

    markAsNotNeeded = () => {
        console.log("++++++++:sendCustomer");
        console.log("docx3 Project Id: " + this.props.projectId)
        console.log("docx32 this.props.user.email " + this.props.user.email)

        console.log("dateNum:" + this.state.dateNum)

        if (!this.props.projectId) {
            alert("No Project Id Sent")
        } else if (!this.props.user && !this.props.user.email) {
            alert("No User provided")
        }else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'addDocumentToLargeProject', {
                apiKey: "asdfasd#",
                projectId: this.props.projectId,
                documentLink: 'not_avail',
                enteredBy: this.props.user.email,
                documentType: this.props.item,
                sentOn: this.state.dateNum,
                vatincluded: 'not_avail'

            })
                .then((response) => {

                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. documented added");

                        //this.resetFeilds();

                        //alert(response.data.message);
                        this.props.reload();
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false })
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({ loading: false })
                });
        }
    }

    render() {

      const checkMarks =  this.props.answer == 'yes'
        ?<div>
            {this.props.item}
            <Icon color='green' name='checkmark' size='large' />
        </div>
        : <div>
            {this.props.item}
            <Icon color='red' name='close' size='large' />
        </div>

        //item={'po'} answer={item.po}
            const sendButton = this.props.answer == 'no'
            ? <div>
                <Button onClick={this.sendMissingSlack} color='purple' icon><Icon name='slack' /> </Button>
                <br/>
                <Button onClick={this.markAsNotNeeded} color='red' icon><Icon name='percent' /> </Button>
            </div>
            :''

        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                {checkMarks}
           
                {sendButton}
            </div>
        );
    }
}

export default ViewLargeProjectDocSendMissingSlack;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/ViewLargeProjectDocSendMissingSlack.js